/*eslint-disable */
define(function (require) {
    'use strict';

    var Backbone = require('backbone'),
        _ = require('underscore'),
        PriceFormatter = require('common/formatter/price-formatter'),
        DateTimeFormatter = require('common/formatter/datetime-formatter'),
        config = require('common/page-config');


    var TimeSlotModel = Backbone.Model.extend({
        initialize: function (modelData) {
            // TODO: ADD SERVICES AND SKUS PRICES TO FIRE WHEN SELECTING A TIME SLOT
            var data = {
                id: modelData.startTime,
                selected: false,
                startTime: modelData.startTime,
                timeText: DateTimeFormatter.getTime('fromMidnight', 'short-time', modelData.startTime),
                price: PriceFormatter.format({
                    currencyCode: config.locale.currencyCode,
                    amount: modelData.salePrice.amount
                }, true)
            };

            if (modelData.fullPrice && modelData.fullPrice.amount !== modelData.salePrice.amount) {
                _.extend(data, {
                    discount: {
                        discounted: PriceFormatter.format({
                            currencyCode: config.locale.currencyCode,
                            amount: modelData.salePrice.amount
                        }, true),
                        full: PriceFormatter.format({
                            currencyCode: config.locale.currencyCode,
                            amount: modelData.fullPrice.amount
                        }, true)
                    }
                });
            }

            this.set(data);
        }
    });

    return TimeSlotModel;
});
